import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { types } from 'mobx-state-tree';
export const CompanyTeamMemberModel = types.model('CompanyTeamMemberModel', {
  id: types.string,
  accountId: types.string,
  companyId: types.string,
  username: types.string,
  firstName: types.string,
  lastName: types.string,
  phone: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
  newEmail: types.maybeNull(types.string),
  userRole: types.string,
  emailConfirmed: types.boolean,
  accountCode: types.string,
  isEnabled: types.boolean,
  portalAccessDateOnly: types.maybeNull(types.string)
}).actions(store => ({
  setUpdateModel(data) {
    try {
      Object.entries(data).forEach(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        store["".concat(key)] = value;
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
})).views(store => ({
  get getFullName() {
    return "".concat(store.firstName, " ").concat(store.lastName);
  },
  get getPhone() {
    return store.phone || 'N/A';
  },
  get getEmail() {
    return store.newEmail || store.email || 'N/A';
  }
}));